export const MATCHER_PRODUCT_STATUSES = {
  Draft: "Draft",
  Archived: "Archive",
  Published: "Active",
  Stopped: "Stopped",
  Corrections: "Corrections",
  Pending: "Moderating",

  DRAFT: "Draft",
  ARCHIVED: "Archive",
  PUBLISHED: "Published",
  STOPPED: "Stopped",
  CORRECTIONS: "Corrections",
  PENDING: "Moderating",
};

export const formatNumber = (n: number) => n.toFixed(2).replace(/\.?0+$/, "");
